export default {
  sections: {
    asap_orders: {
      title: 'Encomendas imediatas',
      fields: {
        has_live_orders: {
          label: 'Encomendas em direto',
          tooltip: 'Ative esta opção apenas quando o restaurante está efetivamente a aceitar encomendas',
        },
        has_asap_orders: {
          label: 'Permite que os clientes façam encomendas imediatas?',
          tooltip: '*As encomendas imediatas baseiam-se no seu tempo de preparação',
        },
      },
    },
    scheduled_orders: {
      title: 'Encomendas agendadas',
      fields: {
        has_scheduled_orders: {
          label: 'Permite que os clientes encomendem com antecedência para horas específicas?',
        },
        has_pre_order: {
          label: 'Permite que os clientes encomendem com mais de um dia de antecedência?',
        },
        max_pre_order_days: {
          label: 'Máximo de dias para agendar',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Notificações de lembrete de encomendas agendadas',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Intervalos de tempo em minutos',
          option: 'Intervalo de {{value}} minutos',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Adicionar quantidade máxima de encomendas por intervalo',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Quantidade máxima de encomendas por intervalo',
          placeholder: '5',
        },
        scheduled_order_option_title: {
          label: 'Título da opção agendar para mais tarde',
          placeholder: 'Agendar para mais tarde',
        },
      },
    },
    other: {
      title: 'Outros',
      fields: {
        order_approval_time_step: {
          label: 'Adicionar / reduzir tempo de encomenda confirmada',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Adicionar minutos extra ao tempo confirmado',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Este restaurante foi suspenso',
      description:
        'Para voltar ao ativo, aceda à <a>página de subscrição</a> e reative o restaurante; depois poderá ativar as encomendas em direto nesta página.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'É necessário ter pelo menos 1 método de encomenda (agendado ou imediato) ativo. Não pode desativar ambos.',
  },
};
